export const chartCalcs = {
  methods: {
    // TODO: set all charts with categories to use this method
    withCategoryCalc(scores, period) {
      period = period || 'report_datas'
      let numberOfResponses = []
      let allScores = []
      //  handle for category when some of them are not available, remove from calculation

      scores.forEach((report) => {
        if(report[period] === null || report[period] === undefined) {
          return false
        }
        Object.keys(report[period].data).forEach((key) => {
          if(key === 'error') {
            return false
          }
          numberOfResponses.push(report[period].data[key])
          allScores.push(key * report[period].data[key])
        })
      })

      numberOfResponses = numberOfResponses.reduce((a, b) => { return a + b }, 0)
      allScores = allScores.reduce((a, b) => { return a + b }, 0)

      if(allScores === 0) {
        return 'N/A'
      }

      return parseInt(allScores / numberOfResponses * 10)
    },

    dysphotopsia(scores, period) {
      period = period || 'report_datas'
      let numberOfResponses = []
      let allScores = []
      let numberOfHighResponses = []
      //  handle for category when some of them are not available, remove from calculation

      scores.forEach((report) => {        
        if(report[period] === null || report[period] === undefined) {
          return false
        }
        Object.keys(report[period].data).forEach((key) => {
          if(key === 'error') {
            return false
          }
          if(key >= 9) {
            numberOfHighResponses.push(report[period].data[key])
          }

          numberOfResponses.push(report[period].data[key])
          allScores.push(key * report[period].data[key])
        })
      })

      numberOfHighResponses = numberOfHighResponses.reduce((a, b) => { return a + b }, 0)
      numberOfResponses = numberOfResponses.reduce((a, b) => { return a + b }, 0)
      allScores = allScores.reduce((a, b) => { return a + b }, 0)

      if(allScores === 0) {
        return 'N/A'
      }
      return parseInt(numberOfHighResponses / numberOfResponses * 100)
      // return parseInt(allScores / numberOfResponses * 10)
    },

    dysphotopsiaSingle(score) {
      let numberOfResponses = []
      let allScores = []
      let numberOfHighResponses = []

      Object.keys(score).forEach((key) => {
        if(key === 'error') {
          return false
        }
        if(key >= 9) {
          numberOfHighResponses.push(score[key])
        }

        numberOfResponses.push(score[key])
        allScores.push(key * score[key])
      })

      numberOfHighResponses = numberOfHighResponses.reduce((a, b) => { return a + b }, 0)
      numberOfResponses = numberOfResponses.reduce((a, b) => { return a + b }, 0)
      allScores = allScores.reduce((a, b) => { return a + b }, 0)
      
      if(allScores === 0) {
        return 'N/A'
      }
      return parseInt(numberOfHighResponses / numberOfResponses * 100)
    },

    // TODO: remove after updating mobile version
    specIndependace(scores) {
      let numberOfResponses = []
      let allScores = []

      scores.forEach((report) => {
        Object.keys(report.report_datas.data).forEach((key) => {
          numberOfResponses.push(report.report_datas.data[key])
          allScores.push(key * report.report_datas.data[key])
        })
      })

      numberOfResponses = numberOfResponses.reduce((a, b) => { return a + b }, 0)
      allScores = allScores.reduce((a, b) => { return a + b }, 0)

      return parseInt(allScores / numberOfResponses * 10)
    },

    rangeMap(scores) {
      let numberOfResponses = []
      let allScores = []

      Object.keys(scores).forEach((key) => {
        numberOfResponses.push(scores[key])
        allScores.push(key * scores[key])
      })

      numberOfResponses = numberOfResponses.reduce((a, b) => { return a + b }, 0)
      allScores = allScores.reduce((a, b) => { return a + b }, 0)

      return parseInt(allScores / numberOfResponses * 10)
    },

    booleanAnswers(scores) {
      let positiveResp = []
      let negativeResp = []

      scores.forEach((report) => {
        Object.keys(report.report_datas.data).forEach((key) => {
          if(key === 'error') {
            return false
          }
          if(key === 'yes') {
            positiveResp.push(report.report_datas.data[key])
          } else {
            negativeResp.push(report.report_datas.data[key])
          }
        })
      })

      positiveResp = positiveResp.reduce((a, b) => { return a + b }, 0)
      negativeResp = negativeResp.reduce((a, b) => { return a + b }, 0)

      if(positiveResp === 0 && negativeResp === 0) {
        return 'N/A'
      }

      return parseInt(positiveResp / (negativeResp + positiveResp) * 100)
    },

    booleanAnswersCategory(score) {
      let positiveResp = []
      let negativeResp = []

      Object.keys(score.report_datas.data).forEach((key) => {
        if(key === 'error') {
          return false
        }
        if(key === 'yes') {
          positiveResp.push(score.report_datas.data[key])
        } else {
          negativeResp.push(score.report_datas.data[key])
        }
      })

      positiveResp = positiveResp.reduce((a, b) => { return a + b }, 0)
      negativeResp = negativeResp.reduce((a, b) => { return a + b }, 0)

      if(positiveResp === 0 && negativeResp === 0) {
        return 'N/A'
      }

      return parseInt(positiveResp / (negativeResp + positiveResp) * 100)
    },

    patientNumbers(scores) {
      return parseInt(scores.active / scores.total * 100)
    },

    refractions(scores) {
      const basicRefraction = {
        percentageValue: 0,
        sumValue: 0,
        donutData: []
      }
      let refraction = Object.assign({}, basicRefraction)
      const allScores = []

      Object.keys(scores).forEach((key) => {
        refraction.donutData.push({name: key, value: scores[key]})
        allScores.push(scores[key])
      })

      refraction.donutData.sort(this.refractionSorter)
      let positives = this.positiveScoreCount(scores)

      refraction.sumValue = allScores.reduce((a, b) => { return a + b }, 0)
      refraction.percentageValue = parseInt(positives / refraction.sumValue * 100)
      if (isNaN(refraction.percentageValue)) return basicRefraction

      return refraction
    },

    positiveScoreCount(scores) {
      let total = 0
      const positives = ['yes', 'yes_definitely', 'yes_to_some_extent',
                         'very_good', 'good', 'extremely_likely', 'likely']
      for (let p of positives) {
        if (scores[p]) total += scores[p]
      }
      return total
    },

    refractionSorter(a, b) {
      const order = ['yes', 'yes_definitely', 'yes_to_some_extent', 'no',
                     'very_good', 'good', 'neither_good_nor_poor', 'poor', 'very_poor',
                     'extremely_likely', 'likely', 'neither_likely_nor_unlikely', 'unlikely', 'extremely_unlikely']

      if (order.includes(a.name) && order.includes(b.name)) {
        if (order.indexOf(a.name) < order.indexOf(b.name)) {
          return -1
        } else {
          return 1
        }
      }

      return 0
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/mixins/chartCalcs.js
// module id = null
// module chunks = 